var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in","name":_vm.transitionName},on:{"before-leave":_vm.startTransition,"after-enter":_vm.finishTransition}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }